import React, { Component } from 'react';
import { Modal, Button, Table, Tooltip, Icon } from 'antd';

class ServiceModal extends Component {
    state = {
        data: [],
        visible: false,
        loading: false,
    }

    show = (data) => {
        this.setState({
            data,
            visible: true,
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    getColumns = () => {
        const columns = [
            {
                title: "评估内容",
                key: "evaluateContent",
                dataIndex: "evaluateContent",
                width: 140,
            },
            {
                title: "访视评估金额（不含税）/元",
                key: "evaluatePrice",
                dataIndex: "evaluatePrice",
                width: 140,
                render: (text, row) => {
                    const { tipValue, evaluateServeName } = row;
                    const isOrange = evaluateServeName == '访视服务' || evaluateServeName == '基础服务' || evaluateServeName == 'DBL服务' || evaluateServeName == '关中心服务' || evaluateServeName == '项目管理服务' || evaluateServeName == '基础协助';
                    return <div>
                        <span style={{ color: isOrange ? '#fc751d' : undefined }}>{(text || text == 0) ? `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}</span>
                        <Tooltip title={<span>
                        {
                            (tipValue || '').split("\n").map(el => (<p>{el}</p>))
                        }
                        </span>}>
                            <a style={{ float: 'right' }}><Icon type="info-circle" /></a>
                        </Tooltip>
                        
                    </div>;
                },
            },
            {
                title: "评估工时（小时）",
                key: "evaluateManHour",
                dataIndex: "evaluateManHour",
                width: 120,
            },
            {
                title: "标准工时计算金额（不含税）/元",
                key: "evaluateProposePrice",
                dataIndex: "evaluateProposePrice",
                width: 160,
            },
        ];
        return columns;
    };

    render() {
        const { visible, loading, data } = this.state;
        return (
            <Modal
                title="SMO访视&非访视相关服务"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="800px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div>
                        <Table
                            dataSource={data}
                            loading={loading}
                            columns={this.getColumns()}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ServiceModal;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/ServiceModal.js